// extracted by mini-css-extract-plugin
export default {"genericList":"genericList_genericList__PCaWr","genericList__actions":"genericList_genericList__actions__mkAvw","genericList__loader":"genericList_genericList__loader__bntRY"};